




















import Vue from "vue";
import {UpgradesList} from "@/consts/upgrades";
import Upgrade from "@/components/Upgrade.vue";

export default Vue.extend({
  data () {
    let catIndex = -1
    let prevCat = ''
    const cats : any[]  = []
    let whatever : any[] = UpgradesList.map((upgrade) : any => {
      const newT : any = {
        ...upgrade,
      }
      newT.catName = upgrade.requiresHero ? upgrade.requiresHero : upgrade.category
      return newT
    })
    whatever = whatever.sort((a, b) => {
      return a.catName > b.catName ? 1 : -1
    })

    whatever.forEach((upgrade) => {
      if (upgrade.catName != prevCat) {
        cats.push({
          name: upgrade.catName,
          upgrades: [],
          heroic: !!upgrade.requiresHero
        })
        prevCat = upgrade.catName
        catIndex++
      }
      cats[catIndex].upgrades.push(upgrade)
    })

    return {
      categories: cats
    }
  },
  components: {
    Upgrade: Upgrade
  },
  methods: {
    down (catIdx : number, idx: number) {
      const up = this.categories[catIdx].upgrades[idx]
      if (up.level == 1) {
        return
      }

      Vue.set(this.categories[catIdx].upgrades[idx], 'level', this.categories[catIdx].upgrades[idx].level-1)
    },
    up (catIdx : number, idx: number) {
      const up = this.categories[catIdx].upgrades[idx]
      if (up.level == up.maxLevel) {
        return
      }
      Vue.set(this.categories[catIdx].upgrades[idx], 'level', this.categories[catIdx].upgrades[idx].level+1)
    }
  }
})
